import React from "react";
import { notFoundPageStyles } from "./styles";

const DefaultPage: React.FC = () => {
  return <div style={notFoundPageStyles.divStyle}></div>;
};

export default DefaultPage;
